import React from 'react';

const CircleXIcon = () => {
  return (
    <svg className="circle-x-icon" width="70" height="70" viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <title>
        Circle X Icon
      </title>
      <g fill="none" fillRule="evenodd">
        <circle fill="currentColor" cx="35" cy="35" r="35" />
        <path fill="#fff" d="M21.565 45.607l24.042-24.042 2.828 2.828-24.042 24.042z" />
        <path fill="#fff" d="M48.435 45.607L24.393 21.565l-2.828 2.828 24.042 24.042z" />
      </g>
    </svg>
  );
};

export default CircleXIcon;
